import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Stars } from "@/components/Stars";
import { WishlistButton } from "@/components/WishlistButton";
import { money } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  const out = product.stock <= 0;
  return (
    <div data-testid={`product-card-${product.id}`} className="group rise bg-[#121215] border border-white/10 hover:border-white/25 transition-colors duration-300"
      style={{ animationDelay: `${index * 60}ms` }}>
      <Link to={`/product/${product.id}`} className="block relative aspect-[4/5] overflow-hidden bg-neutral-900">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-3 left-3 bg-black/70 backdrop-blur px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-white">{product.category}</span>
        <WishlistButton productId={product.id} className="absolute top-3 right-3 w-8 h-8 bg-black/70 backdrop-blur" />
        {!product.is_digital && product.stock > 0 && product.stock <= 5 && (
          <span className="absolute bottom-3 left-3 bg-[#FF9500] px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-black font-bold">Only {product.stock} left</span>
        )}
        {out && <span className="absolute inset-0 bg-black/60 grid place-items-center font-display text-2xl uppercase font-black">Sold out</span>}
      </Link>
      <div className="p-5 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <Link to={`/product/${product.id}`} className="font-display uppercase font-bold text-lg leading-tight text-white hover:text-[#FF3B30] transition-colors line-clamp-2">
            {product.name}
          </Link>
          <div className="flex items-center gap-3 mt-1">
            <p className="font-mono text-sm text-neutral-400" data-testid={`product-price-${product.id}`}>{product.variants?.length > 1 ? `From ${money(Math.min(...product.variants.map((v) => v.price)))}` : money(product.price)}</p>
            {product.rating_count > 0 && (
              <span className="flex items-center gap-1" data-testid={`product-rating-${product.id}`}><Stars value={product.rating_avg} size="w-3 h-3" /><span className="font-mono text-[10px] text-neutral-500">({product.rating_count})</span></span>
            )}
          </div>
        </div>
        <button data-testid={`quick-add-${product.id}`} disabled={out} onClick={() => add(product)} aria-label="Add to cart"
          className="shrink-0 w-10 h-10 grid place-items-center border border-white/15 hover:bg-[#FF3B30] hover:border-[#FF3B30] hover:text-white transition-colors disabled:opacity-30 disabled:pointer-events-none">
          <Plus className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
